import { ReactNode } from 'react';
import styles from './Accordion.module.scss';

interface AccordionShellProps {
  children: ReactNode;
}

function AccordionShell({ children }: AccordionShellProps) {
  return <div className={`${styles.accordion} ${styles.backgroundWhite}`}>{children}</div>;
}

export default AccordionShell;
